<template>
  <div class="Policy">
    <ld-header fixed>
      {{ $t('A020','协议直减') }}
    </ld-header>

    <div class="pad8">
      <div
        class="policy-item"
        v-for="policy in policyList"
        :key="policy.code"
      >
        <h3 class="policy-title">
          <img :src="policy.logo">
          {{ policy.airlineName }}
        </h3>
        <table
          class="policy-table"
          border="1"
          cellpadding="0"
          cellspacing="0"
        >
          <tr>
            <th>
              适用航程
            </th>
            <th>舱位</th>
            <th>折上折优惠</th>
          </tr>
          <tr
            v-for="(voyage, index) in policy.voyageList"
            :key="index"
          >
            <td>
              <div
                class="left"
                v-html="voyage.voyageName"
              />
            </td>
            <td>
              <div>
                {{ voyage.cabin }}
              </div>
            </td>
            <td class="red">
              <div class="right">
                {{ voyage.qfPercent }}
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Policy from './Policy'

export default {
  data () {
    return {
      policyList: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList() {
      const { data = [] } = await this.$api['tkQuery/AgreementPolicy']({
        corpId: this.empInfo.corpId
      })
      this.policyList = data.map(policy => new Policy(policy))
    }
  },
  computed: {
    ...mapState({
      empInfo: state => state.app.userInfo.empInfo
    })
  }
}
</script>

<style lang="less">
.Policy {
  padding-top: 50px;

  .pad8 {
    padding: 8px;
  }
  
  .policy-title {
    img {
      width: 20px;
      vertical-align: text-bottom;
    }
  }
  
  .policy-table {
    width: 100%;
    text-align: center;
    background-color: @color-background-white;

    td, th {
      padding: 5px;

      div {
        display: inline-block;
        word-break: break-word;
      }
      
      div.left {
        min-width: 40px;
        max-width: 180px;
      }
      div.right {
        width: 45px;
      }
    }

    th {
      background-color: @color-background-lightYellow;
    }
  }
  
}
</style>